export const counter_options = {
  FETCH_COUNTER_OPTIONS_SUCCESS: 'FETCH_COUNTER_OPTIONS_SUCCESS',
  FETCH_COUNTER_OPTIONS_LOADING: 'FETCH_COUNTER_OPTIONS_LOADING',
};
